import { useState, useEffect, useCallback } from 'react';

/**
 * Hook pour calculer le temps restant avant le reset quotidien (minuit UTC)
 * @returns {Object} { timeToReset, formattedTime, hoursLeft, minutesLeft, secondsLeft }
 */
export const useResetCountdown = () => {
  const [countdown, setCountdown] = useState({ h: 0, m: 0, s: 0 });

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();
      const nextMidnight = new Date(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 0, 0, 0)
      );
      const diff = nextMidnight - now;

      if (diff <= 0) {
        setCountdown({ h: 0, m: 0, s: 0 });
        return;
      }

      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setCountdown({ h, m, s });
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);

  // Format court: "12h 34m 56s"
  const shortFormat = `${countdown.h}h ${countdown.m}m ${countdown.s}s`;

  // Format explicite: "12 heures, 34 minutes"
  const explicitFormat = useCallback(() => {
    const parts = [];
    if (countdown.h > 0) {
      parts.push(`${countdown.h} heure${countdown.h > 1 ? 's' : ''}`);
    }
    if (countdown.m > 0) {
      parts.push(`${countdown.m} minute${countdown.m > 1 ? 's' : ''}`);
    }
    // N'afficher les secondes que si moins d'une heure
    if (countdown.h === 0 && countdown.s > 0) {
      parts.push(`${countdown.s} seconde${countdown.s > 1 ? 's' : ''}`);
    }
    return parts.join(', ') || 'quelques secondes';
  }, [countdown]);

  return {
    hoursLeft: countdown.h,
    minutesLeft: countdown.m,
    secondsLeft: countdown.s,
    shortFormat,
    explicitFormat: explicitFormat(),
    // Format pour le badge: "Nouveau téléchargement dans Xh Ym"
    badgeText: `Nouveau téléchargement gratuit dans ${shortFormat}`,
  };
};

export default useResetCountdown;
